export default __webpack_public_path__ + "static/media/menu-recipes-icon.88f918f5.svg";